import React from 'react';
import { MIN_SKILLS_TO_REMIND } from 'containers/Gamification';

export default function YouGotSkillsBadge() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="70"
      height="75"
      fill="none"
      viewBox="0 0 70 75"
    >
      <title>{`You’ve added at least ${MIN_SKILLS_TO_REMIND} skills to your profile!`}</title>
      <path
        fill="url(#paint0_linear_418_20202)"
        d="M33.3 71.06l-28-15.468a3.477 3.477 0 01-1.8-3.042V21.845c0-1.264.69-2.429 1.8-3.043l28-15.467a3.518 3.518 0 013.4 0l28 15.467a3.477 3.477 0 011.8 3.043V52.55c0 1.264-.69 2.429-1.8 3.042l-28 15.468a3.517 3.517 0 01-3.4 0z"
      />
      <mask
        id="mask0_418_20202"
        style={{ maskType: 'alpha' }}
        width="64"
        height="70"
        x="3"
        y="2"
        maskUnits="userSpaceOnUse"
      >
        <path
          fill="url(#paint1_linear_418_20202)"
          d="M33.3 71.06l-28-15.468a3.477 3.477 0 01-1.8-3.042V21.845c0-1.264.69-2.429 1.8-3.043l28-15.467a3.518 3.518 0 013.4 0l28 15.467a3.477 3.477 0 011.8 3.043V52.55c0 1.264-.69 2.429-1.8 3.042l-28 15.468a3.517 3.517 0 01-3.4 0z"
        />
      </mask>
      <g mask="url(#mask0_418_20202)">
        <path
          fill="#171717"
          d="M37.384 82.496l25.678-25.393-4.888.62 6.71-2.461 4.91-4.924-12.784 3.747L77.56 42.67l3.7-3.672c.407-.403 1.044-1.045 1.34-1.329L55.308 50.664l24.986-19.717-1.296-1.286L53.089 47.56l21.066-22.703-1.308-1.296L50.42 44.847 67.916 18.66l-1.285-1.275-19.264 25.208 14.08-30.35-1.274-1.263-16.189 29.86L54.177 5.03 53.11 3.974 40.382 39.651l5.294-43.052-.813-.806-8.204 43.259-1.68-52.246a2.528 2.528 0 00-.407 0l-1.691 52.246L24.654-4.24l-.812.817 5.316 43.074-12.74-35.71-1.099 1.09 10.247 35.807-16.2-29.903L8.092 12.2 22.194 42.58 2.81 17.44l-1.186 1.176L19.13 44.836l-22.449-21.33-1.296 1.275 21.032 22.79-25.865-17.997-1.252 1.242L14.2 50.664-12.6 38.213l.857.85 3.8 3.769 20.428 11.253L-.32 50.403l4.92 4.87 6.711 2.461-4.887-.62 25.019 24.794c2.109 2.102 3.339 3.366 5.942.599v-.011z"
          opacity="0.4"
        />
        <path
          fill="url(#paint2_linear_418_20202)"
          d="M34.613 53.975h-1.911c-.212-.023-.423-.053-.642-.076-2.938-.34-5.597-1.382-7.924-3.232-3.044-2.417-4.947-5.537-5.672-9.366-.114-.597-.174-1.208-.265-1.813v-1.91c.098-.688.144-1.383.302-2.047 1.534-6.435 5.514-10.491 11.942-12.077 1.096-.272 2.251-.287 3.384-.348.952-.053 1.912-.007 2.856-.007.445-2.644 1.926-4.102 4.14-4.102 2.212 0 3.693 1.458 4.138 4.11h4.147v4.146c2.463.105 3.989 1.979 4.087 3.935.09 1.82-1.201 4.116-4.102 4.313V38.498c0 2.349-.468 4.6-1.518 6.7-2.327 4.622-6.028 7.492-11.119 8.526-.612.121-1.231.182-1.85.272l.007-.022zm12.433-21.209c.537.19 1.012.37 1.496.529a1.968 1.968 0 002.168-.68c.566-.725.596-1.7.068-2.447-.522-.74-1.413-1.035-2.297-.748-.468.159-.936.333-1.442.514v-4.819h-4.782c.181-.498.348-.959.506-1.42a2.012 2.012 0 00-1.291-2.568 2.046 2.046 0 00-2.576 1.307c-.159.476-.113.936.06 1.405.159.415.31.838.476 1.306h-4.728v2.07c2.817.189 4.048 2.349 4.079 3.995.022 1.02-.28 1.934-.93 2.72-.808.989-1.88 1.472-3.15 1.525v2.055h4.676c-.18.498-.355.951-.498 1.42a2.048 2.048 0 002.032 2.666c1.352-.046 2.273-1.375 1.858-2.69-.144-.46-.317-.92-.499-1.42h4.767V32.76l.007.007zM34.673 51.852c6.61-.377 11.995-6.042 12.298-12.28h-2.025c-.105 2.439-1.956 3.972-3.935 4.078-1.836.09-4.124-1.216-4.306-4.078h-2.024v4.682c-.49-.173-.937-.34-1.39-.483-.86-.28-1.737-.015-2.266.672a2.04 2.04 0 00-.075 2.425 2.035 2.035 0 002.319.785c.46-.143.921-.317 1.42-.49v4.697l-.016-.008zm-2.039-14.365v-4.683c.544.181 1.05.385 1.571.521 1.043.272 2.108-.347 2.432-1.367a2.052 2.052 0 00-1.238-2.53c-.514-.196-1.028-.159-1.534.03-.4.151-.8.287-1.246.453v-4.743c-3.497.332-6.436 1.737-8.808 4.29-2.092 2.259-3.247 4.94-3.52 8.029h2.055c.159-2.644 2.123-3.965 3.867-4.071a4.002 4.002 0 012.75.838c1.057.816 1.564 1.919 1.632 3.24h2.039v-.007zm-.023 12.349c-2.817-.197-4.048-2.35-4.086-4.003-.023-1.02.28-1.934.929-2.72.808-.989 1.88-1.472 3.15-1.525v-2.054h-4.676c.181-.499.355-.96.499-1.42a2.052 2.052 0 00-2.002-2.666c-1.367.022-2.311 1.36-1.896 2.688.144.461.317.914.499 1.428h-4.714c.453 6.994 6.481 12.054 12.29 12.266v-2.002l.007.008z"
        />
      </g>
      <path
        stroke="#E9E9E9"
        strokeWidth="7"
        d="M31.82 69.968h0a6.516 6.516 0 006.363 0h0L62.45 56.395s0 0 0 0A6.558 6.558 0 0065.8 50.67V23.725A6.558 6.558 0 0062.45 18s0 0 0 0L38.184 4.427h0a6.516 6.516 0 00-6.363 0h0L7.553 18s0 0 0 0A6.557 6.557 0 004.2 23.725V50.67a6.557 6.557 0 003.352 5.725L31.82 69.968z"
      />
      <path
        stroke="#0AB88A"
        strokeWidth="5"
        d="M32.27 69.787h0a5.599 5.599 0 005.46 0h0l24.888-13.889s0 0 0 0a5.627 5.627 0 002.882-4.914V23.41c0-2.037-1.1-3.92-2.882-4.915L37.729 4.608h0a5.6 5.6 0 00-5.458 0h0L7.382 18.496s0 0 0 0A5.627 5.627 0 004.5 23.412v27.573c0 2.037 1.1 3.92 2.882 4.914l24.889 13.89z"
      />
      <path
        stroke="url(#paint3_linear_418_20202)"
        strokeWidth="2"
        d="M11.072 51.717h0a1.918 1.918 0 01-.97-1.673V24.35c0-.7.375-1.34.97-1.674h0L34.094 9.736s0 0 0 0a1.848 1.848 0 011.815 0l23.022 12.941h0c.595.335.97.974.97 1.674v25.693c0 .7-.375 1.339-.97 1.673h0L35.91 64.66a1.849 1.849 0 01-1.815 0L11.072 51.717z"
      />
      <defs>
        <linearGradient
          id="paint0_linear_418_20202"
          x1="4.168"
          x2="71.076"
          y1="70.762"
          y2="9.316"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#574F47" />
          <stop offset="1" stopColor="#292929" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_418_20202"
          x1="4.168"
          x2="71.076"
          y1="70.762"
          y2="9.316"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B9B6B4" />
          <stop offset="1" stopColor="#ACACAB" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_418_20202"
          x1="53.199"
          x2="17.046"
          y1="28.318"
          y2="31.236"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FAFDFD" />
          <stop offset="1" stopColor="#CBCBCB" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_418_20202"
          x1="63.89"
          x2="-0.979"
          y1="60.157"
          y2="30.683"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEB914" />
          <stop offset="1" stopColor="#FFE501" />
        </linearGradient>
      </defs>
    </svg>
  );
}
